var render = function render(){var _vm=this,_c=_vm._self._c;return _c('videon-card',{attrs:{"heading":"Processing...","max-width":"440"}},[_c('v-card-text',[_c('v-row',{staticClass:"justify-center ma-10"},[_c('v-progress-circular',{attrs:{"size":100,"width":10,"indeterminate":"","color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }